module.exports = __webpack_public_path__ + "img/popup_btn_know.88fb6505.png";